import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=2f55e148&scoped=true&"
import script from "./AccountSettings.vue?vue&type=script&lang=js&"
export * from "./AccountSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=2f55e148&scoped=true&lang=scss&"
import style1 from "~/assets/scss/sections/navbar/account-settings.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f55e148",
  null
  
)

export default component.exports